<div class="row">
  <div class="col-sm-12">
    <app-card [cardOptionBtnValue]="'global.add_btn_text'|translate "
              [cardOptionBtnIcon]="'feather icon-plus'"
              [cardOptionBtn]="true"
              [cardRouterLink]="'/back-office/fabric-collection/add'"
              [title]="'global.overview'|translate">
      <app-grid [grid]="grid"></app-grid>
      <button class="btn btn-primary ripple light pull-right my-3" (click)="goToArchive()" type="button">{{'global.view_archive'|translate}}</button>
    </app-card>
  </div>
</div>

<ng-template #dealerPriceTemp let-row="row" let-value="value" let-column="column">
  {{((row.dealerPrice) ? row.dealerPrice : row.customerPrice)| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}
</ng-template>
<ng-template #customerPriceTemp let-row="row" let-value="value" let-column="column">
  {{row.customerPrice| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}
</ng-template>

<app-modal-basic #deleteModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'Fabric Collection'} }}</h4>
    <button type="button" class="close basic-close" (click)="deleteModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}}: <span [innerHTML]="fabricCollectionName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
    <button [disabled]="disableDeleteButton" type="button" class="btn btn-primary ripple light" (click)="softDelete()">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>
